import React, { useState, useEffect } from "react";
import {
	Modal,
	Form,
	Select,
	DatePicker,
	Input,
	Button,
	message,
	Typography,
} from "antd";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";

const { TextArea } = Input;
const { Option } = Select;

const EditClassificationModal = ({
	visible,
	onCancel,
	onSuccess,
	userId,
	currentClassification,
}) => {
	const isMobile = useIsMobile();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [classifications, setClassifications] = useState([]);

	useEffect(() => {
		if (visible) {
			getClassifications();
			form.setFieldsValue({
				changed_classification: currentClassification,
				changed_date: dayjs(),
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- form is stable
	}, [visible, currentClassification]);

	const getClassifications = async () => {
		try {
			const response = await useAxios.get(
				"/users/classifications/"
			);
			if (response.status === 200) {
				setClassifications(response.data);
			}
		} catch (error) {
			message.error("분류 목록을 불러오는데 실패했습니다.");
		}
	};

	const handleSubmit = async () => {
		try {
			setLoading(true);
			const values = await form.validateFields();

			const updateData = {
				classification_id:
					values.changed_classification,
				classification_change: {
					changed_date:
						values.changed_date.format(
							"YYYY-MM-DD"
						),
					changed_classification:
						classifications.find(
							(c) =>
								c.id ===
								values.changed_classification
						)?.name,
					reason: values.reason || "",
				},
			};

			const response = await useAxios.put(
				`/users/update-classification/${userId}/`,
				updateData
			);

			if (response.status === 200) {
				message.success(
					"분류가 성공적으로 수정되었습니다."
				);
				onSuccess();
				form.resetFields();
			}
		} catch (error) {
			message.error("분류 수정에 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		form.resetFields();
		onCancel();
	};

	return (
		<Modal
			title="분류 수정"
			open={visible}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>
					취소
				</Button>,
				<Button
					key="submit"
					type="primary"
					loading={loading}
					onClick={handleSubmit}>
					수정
				</Button>,
			]}
			width={500}>
			<Form form={form} layout="vertical">
				<Form.Item
					name="changed_classification"
					label="분류"
					rules={[
						{
							required: true,
							message: "분류를 선택해주세요",
						},
					]}>
					<Select placeholder="분류 선택">
						{classifications.map(
							(classification) => (
								<Option
									key={
										classification.id
									}
									value={
										classification.id
									}>
									{
										classification.name
									}
								</Option>
							)
						)}
					</Select>
				</Form.Item>

				<Form.Item
					name="changed_date"
					label="변경일"
					rules={[
						{
							required: true,
							message: "변경일을 선택해주세요",
						},
					]}>
					<DatePicker
						inputReadOnly={isMobile}
						style={{ width: "100%" }}
						format="YYYY-MM-DD"
						placeholder="변경일 선택"
					/>
				</Form.Item>

				<Form.Item name="reason" label="변경 사유">
					<TextArea
						rows={3}
						placeholder="변경 사유를 입력해주세요"
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditClassificationModal;
